__turbopack_context__.v({
  "bg-spin": "style-module-scss-module__9-sVia__bg-spin",
  "mobileSlider": "style-module-scss-module__9-sVia__mobileSlider",
  "motionTrail": "style-module-scss-module__9-sVia__motionTrail",
  "patternBg": "style-module-scss-module__9-sVia__patternBg",
  "section": "style-module-scss-module__9-sVia__section",
  "title": "style-module-scss-module__9-sVia__title",
});
